import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from './localesKeysTypes';

interface StringsType {
  acceptTaskResult: LocalesKey;
  accordingToTheRulesForRoundingContractorInvoiceAmountsUpTo001TheAmountMayDifferFromThePaidByAFewCents: LocalesKey;
  addDescriptionToYourTaskToProvideMoreInformationToYourTeam: LocalesKey;
  addYourCommentHere: LocalesKey;
  afterThisPeriodTheyWillReturnToDeepArchiveAndMustBeRestoredAgainToAccessThem: LocalesKey;
  allFiles: LocalesKey;
  allInvoiceTagsWillBeUpdated: LocalesKey;
  alreadyAdded: LocalesKey;
  applyToAll: LocalesKey;
  approveTaskResult: LocalesKey;
  areYouSureThisActionCannotBeUndone: LocalesKey;
  areYouSureYouWantToAbortTheTask: LocalesKey;
  areYouSureYouWantToAbortTheTasks: LocalesKey;
  areYouSureYouWantToBlockThisAccount: LocalesKey;
  areYouSureYouWantToLeaveTheCompanies: LocalesKey;
  areYouSureYouWantToJoinThePerformersTeamsOfTheseCompanies: LocalesKey;
  areYouSureYouWantToDenyAccess: LocalesKey;
  areYouSureYouWantToBlockThisCompany: LocalesKey;
  areYouSureYouWantToCancelCreatingTasks: LocalesKey;
  areYouSureYouWantToCancelTheTask: LocalesKey;
  areYouSureYouWantToClearAllFormFields: LocalesKey;
  areYouSureYouWantToClearSelected: LocalesKey;
  areYouSureYouWantToCloseTheTask: LocalesKey;
  areYouSureYouWantToContinueTheTask: LocalesKey;
  areYouSureYouWantToCreateMissingWhiteboardShapes: LocalesKey;
  areYouSureYouWantToCreateMissingWhiteboardComments: LocalesKey;
  areYouSureYouWantToCreateMissingWhiteboardImage: LocalesKey;
  areYouSureYouWantToDeleteAccount: LocalesKey;
  areYouSureYouWantToDeleteTab: LocalesKey;
  areYouSureYouWantToMuteNotifications: LocalesKey;
  areYouSureYouWantToUnmuteNotifications: LocalesKey;
  areYouSureYouWantToDeleteSavedFilterThisActionCannotBeUndone: LocalesKey;
  areYouSureYouWantToDeleteTheTask: LocalesKey;
  areYouSureYouWantToDeleteThisAccount: LocalesKey;
  areYouSureYouWantToDeleteThisActionCannotBeUndone: LocalesKey;
  areYouSureYouWantToDeleteThisRecordThisActionCannotBeUndone: LocalesKey;
  areYouSureYouWantToDeleteThisTemplate: LocalesKey;
  areYouSureYouWantToUngroup: LocalesKey;
  areYouSureYouWantToRemoveTheseTasks: LocalesKey;
  areYouSureYouWantToDeleteThisThread: LocalesKey;
  areYouSureYouWantToDeleteThisTransactionImports: LocalesKey;
  areYouSureYouWantToDeletTheBillingAddress: LocalesKey;
  areYouSureYouWantToDeletTheField: LocalesKey;
  areYouSureYouWantToRemoveItemsFromDraft: LocalesKey;
  areYouSureYouWantToRemoveThisUserFromCompany: LocalesKey;
  areYouSureYouWantToRemoveAllCMsFromTheseCompanies: LocalesKey;
  areYouSureYouWantToReplaceActiveWhiteboardWithBackup: LocalesKey;
  areYouSureYouWantToUnblockThisAccount: LocalesKey;
  asTeamMemberOf: LocalesKey;
  atLeastOneTaskMustBeEntered: LocalesKey;
  beforeYouAcceptTheTaskWeLikeToRemindYouThat: LocalesKey;
  byRatingTasksYouAcceptTaskResultsForTheClient: LocalesKey;
  cancelThisFileToTryAgain: LocalesKey;
  changeStudio: LocalesKey;
  changeStudioPage: LocalesKey;
  changeVisibility: LocalesKey;
  clearFilters: LocalesKey;
  commentHere: LocalesKey;
  collapseAll: LocalesKey;
  convertFromMarkdown: LocalesKey;
  contractorPercentagesTotalOver100PleaseAdjust: LocalesKey;
  createStudio: LocalesKey;
  createStudioPage: LocalesKey;
  deleteThread: LocalesKey;
  dragAndDropFilesOr: LocalesKey;
  dragImageHereOrClickToSelect: LocalesKey;
  dropTheFilesHere: LocalesKey;
  editColumn: LocalesKey;
  errorLoadingImage: LocalesKey;
  extractingMessages: LocalesKey;
  fileIsUploading: LocalesKey;
  filesInDeepArchive: LocalesKey;
  filterByDate: LocalesKey;
  generateApplicationToken1: LocalesKey;
  generateApplicationToken2: LocalesKey;
  helpWithTextFormatting: LocalesKey;
  hereIsABriefOfOurServicesAndPricesNo: LocalesKey;
  hereIsTheExampleOfWhatYoullGet: LocalesKey;
  hideColumn: LocalesKey;
  notificationsForThisTaskAreNowDisabledExceptWhenYoureMentioned: LocalesKey;
  notificationsForThisTaskAreNowEnabled: LocalesKey;
  notificationsForThisProjectAreNowDisabledExceptWhenYoureMentioned: LocalesKey;
  notificationsForThisProjectAreNowEnabled: LocalesKey;
  hiddenAnd: LocalesKey;
  iConfirmThatIHaveReadAndAgreeTo: LocalesKey;
  ifYouAreUnsureWhoToInviteNowYouCanSkip: LocalesKey;
  ifYouWantTheResultTweakedOrAdjustedAfterThatItWillBeANewTaskAndChargedAccordingly: LocalesKey;
  iHaveReadAndAgreeToTheUpdatedInformation: LocalesKey;
  imageUploadFailed: LocalesKey;
  indicateHowMuchDoYouAgreeWithTheFollowingStatement: LocalesKey;
  inviteYourTeamMembers: LocalesKey;
  learnAboutItemTypes: LocalesKey;
  letsCreateYourFirstProject: LocalesKey;
  letsDiveIn: LocalesKey;
  letsGetToKnowEachOther: LocalesKey;
  linkToTheCRMaUsernameAndPasswordCombinationUsedForLoggingInToOnlineAccountEtc: LocalesKey;
  noItemsMatchYourSearchCriteria: LocalesKey;
  noRowsToShow: LocalesKey;
  noThanks: LocalesKey;
  mutedThisByAccident: LocalesKey;
  onceYouAcceptTheTaskItWillCloseAndYouWillNotBeAbleToLeaveNewCommentsInIt: LocalesKey;
  orChangeTableSettingsToAlwaysShowHiddenElements: LocalesKey;
  ourExpertTeamWillWorkCloselyWith: LocalesKey;
  pleaseAdjustYourFiltersAndTryAgainOr: LocalesKey;
  pleaseClickOnStarsToRateTheResult: LocalesKey;
  pleaseConsiderCreatingANewTaskWithFurtherInstructionsOrContactUsAtProjectThreadDirectly: LocalesKey;
  pleaseProvideYourAddress: LocalesKey;
  pleaseRateResults: LocalesKey;
  pleaseRateTaskRusult: LocalesKey;
  pleaseRateTheTask: LocalesKey;
  pleaseUpdateToTheLatestVersionThisWillRefreshThePage: LocalesKey;
  pleaseWaitYourDownloadWillBeReadyInSeveralMinutes: LocalesKey;
  previewTextFormatting: LocalesKey;
  refreshAccessToken: LocalesKey;
  remainAccessibleFor: LocalesKey;
  restorationRequestAlreadySentEstimatedRestorationDate: LocalesKey;
  reverseChargeForServices: LocalesKey;
  saveFieldInCompanyProfile: LocalesKey;
  submitFilesWhenUploaded: LocalesKey;
  searchForProductsOnYourImageUsingAI: LocalesKey;
  selectInvoiceFromTheList: LocalesKey;
  selectedFilesHaveBeenSuccessfullyScheduledForRestoration: LocalesKey;
  selectTheObjectYouWantToSearchInOur3DLibrary: LocalesKey;
  sendEmailNotification: LocalesKey;
  sendToWhiteboard: LocalesKey;
  startByOutliningYourProjectVisionBe: LocalesKey;
  startTypingToSearchForClients: LocalesKey;
  studioEmbedId: LocalesKey;
  textFormattingHelp: LocalesKey;
  theFunctionalityIsNotAvailableForSearchWithAI: LocalesKey;
  thePaymentHasBeenAcceptedForProcessingUsually: LocalesKey;
  thePaymentHasBeenCanceled: LocalesKey;
  thereAreNoNonValidTasks: LocalesKey;
  thereAreNoValidTasks: LocalesKey;
  theseFilesAreStoredInDeepArchiveBeforeDownloadingTheyMustFirstBeRestoredRestorationTypicallyTakesUpTo: LocalesKey;
  onceRestoredTheFilesWillBeAvailableForDownloadFor: LocalesKey;
  thereIsNoBillingInfoInTheCompany: LocalesKey;
  theTaskResultHasBeenApproved: LocalesKey;
  thisAccountHasBeenDeletedPleaseContactSupport: LocalesKey;
  thisActionWillAffect: LocalesKey;
  thisActionWillAddARecordTo: LocalesKey;
  thisCommentWouldBeVisibleOnlyInTimeline: LocalesKey;
  toSetUpTheInterfaceForTheRightWorkflow: LocalesKey;
  totalAmountOfImportedItems: LocalesKey;
  unsureClickStartProjectAnd: LocalesKey;
  unlessYoureMentionedDirectly: LocalesKey;
  unableToSplitInvoicesOneOrMoreInvoicesAreAssignedToDifferentGeneralLedger: LocalesKey;
  unableToStartTask: LocalesKey;
  itemsAssociatedWithDifferentLedgersInTheSmartContractAllItemsMustUseTheSameLedgerToContinuePleaseContactThePmOfThisTaskToResolveThisIssue: LocalesKey;
  updateCost: LocalesKey;
  updateDueDate: LocalesKey;
  uploadAPhotoOfARoomSelectACategory: LocalesKey;
  uploadedPercent: LocalesKey;
  uploadASinglePhotoOfTheRoomAndOurAIWill: LocalesKey;
  weAreOnline: LocalesKey;
  weAreReadyToHelp: LocalesKey;
  whiteboardDataHasBeenUpdatedPleaseReloadThePage: LocalesKey;
  writeHereWarning: LocalesKey;
  youAreAboutToChangeTheClientExistingTasksItemsWillBeDeletedAreYouSureYouWantToProceed: LocalesKey;
  youCanAlwaysDownloadTheFilesToSeeThemOnYourDeviceBeforeAcceptingTheTask: LocalesKey;
  yourPaymentIsBeingProcessedBeAdvisedThat: LocalesKey;
  youWillBeRedirectedToThePaymentsPageIn: LocalesKey;
  youWillBeRedirectedToTheProjectPageIn: LocalesKey;
  youveSuccessfullyUnsubscribedFrom: LocalesKey;
  youveSuccessfullySubscribedTo: LocalesKey;
  youWontReceiveNotificationsFor: LocalesKey;
  restoreSelectedFiles: LocalesKey;
  yesUnmuteEverything: LocalesKey;
  yesMuteEverything: LocalesKey;
  wrapContent: LocalesKey;
  clipContent: LocalesKey;
  uploadFailedPleaseRenameTheFileUsingLatinLettersOnly: LocalesKey;
}

export const stringsKeys = keyPathMirror<StringsType, string>(
  {
    acceptTaskResult: null,
    addYourCommentHere: null,
    addDescriptionToYourTaskToProvideMoreInformationToYourTeam: null,
    accordingToTheRulesForRoundingContractorInvoiceAmountsUpTo001TheAmountMayDifferFromThePaidByAFewCents:
      null,
    afterThisPeriodTheyWillReturnToDeepArchiveAndMustBeRestoredAgainToAccessThem:
      null,
    allFiles: null,
    allInvoiceTagsWillBeUpdated: null,
    alreadyAdded: null,
    applyToAll: null,
    approveTaskResult: null,
    areYouSureThisActionCannotBeUndone: null,
    areYouSureYouWantToBlockThisAccount: null,
    areYouSureYouWantToLeaveTheCompanies: null,
    areYouSureYouWantToJoinThePerformersTeamsOfTheseCompanies: null,
    areYouSureYouWantToDenyAccess: null,
    areYouSureYouWantToBlockThisCompany: null,
    areYouSureYouWantToAbortTheTask: null,
    areYouSureYouWantToAbortTheTasks: null,
    areYouSureYouWantToDeleteTheTask: null,
    areYouSureYouWantToCancelTheTask: null,
    areYouSureYouWantToCloseTheTask: null,
    areYouSureYouWantToContinueTheTask: null,
    areYouSureYouWantToCancelCreatingTasks: null,
    areYouSureYouWantToClearAllFormFields: null,
    areYouSureYouWantToClearSelected: null,
    areYouSureYouWantToCreateMissingWhiteboardShapes: null,
    areYouSureYouWantToCreateMissingWhiteboardComments: null,
    areYouSureYouWantToCreateMissingWhiteboardImage: null,
    areYouSureYouWantToDeletTheBillingAddress: null,
    areYouSureYouWantToDeleteAccount: null,
    areYouSureYouWantToDeleteTab: null,
    areYouSureYouWantToMuteNotifications: null,
    areYouSureYouWantToUnmuteNotifications: null,
    areYouSureYouWantToDeleteThisAccount: null,
    areYouSureYouWantToDeleteThisActionCannotBeUndone: null,
    areYouSureYouWantToDeleteThisRecordThisActionCannotBeUndone: null,
    areYouSureYouWantToDeleteThisTransactionImports: null,
    areYouSureYouWantToDeleteThisThread: null,
    areYouSureYouWantToDeleteThisTemplate: null,
    areYouSureYouWantToUngroup: null,
    areYouSureYouWantToRemoveTheseTasks: null,
    areYouSureYouWantToDeletTheField: null,
    areYouSureYouWantToRemoveThisUserFromCompany: null,
    areYouSureYouWantToRemoveAllCMsFromTheseCompanies: null,
    areYouSureYouWantToRemoveItemsFromDraft: null,
    areYouSureYouWantToUnblockThisAccount: null,
    areYouSureYouWantToReplaceActiveWhiteboardWithBackup: null,
    areYouSureYouWantToDeleteSavedFilterThisActionCannotBeUndone: null,
    atLeastOneTaskMustBeEntered: null,
    beforeYouAcceptTheTaskWeLikeToRemindYouThat: null,
    byRatingTasksYouAcceptTaskResultsForTheClient: null,
    cancelThisFileToTryAgain: null,
    changeVisibility: null,
    clearFilters: null,
    commentHere: null,
    collapseAll: null,
    convertFromMarkdown: null,
    contractorPercentagesTotalOver100PleaseAdjust: null,
    changeStudioPage: null,
    changeStudio: null,
    createStudioPage: null,
    createStudio: null,
    deleteThread: null,
    dragAndDropFilesOr: null,
    dragImageHereOrClickToSelect: null,
    dropTheFilesHere: null,
    editColumn: null,
    errorLoadingImage: null,
    extractingMessages: null,
    fileIsUploading: null,
    filesInDeepArchive: null,
    filterByDate: null,
    helpWithTextFormatting: null,
    hiddenAnd: null,
    hereIsTheExampleOfWhatYoullGet: null,
    hideColumn: null,
    notificationsForThisTaskAreNowDisabledExceptWhenYoureMentioned: null,
    notificationsForThisTaskAreNowEnabled: null,
    notificationsForThisProjectAreNowDisabledExceptWhenYoureMentioned: null,
    notificationsForThisProjectAreNowEnabled: null,
    iConfirmThatIHaveReadAndAgreeTo: null,
    inviteYourTeamMembers: null,
    learnAboutItemTypes: null,
    letsGetToKnowEachOther: null,
    ifYouAreUnsureWhoToInviteNowYouCanSkip: null,
    ifYouWantTheResultTweakedOrAdjustedAfterThatItWillBeANewTaskAndChargedAccordingly:
      null,
    indicateHowMuchDoYouAgreeWithTheFollowingStatement: null,
    iHaveReadAndAgreeToTheUpdatedInformation: null,
    imageUploadFailed: null,
    linkToTheCRMaUsernameAndPasswordCombinationUsedForLoggingInToOnlineAccountEtc:
      null,
    onceYouAcceptTheTaskItWillCloseAndYouWillNotBeAbleToLeaveNewCommentsInIt:
      null,
    orChangeTableSettingsToAlwaysShowHiddenElements: null,
    pleaseClickOnStarsToRateTheResult: null,
    pleaseConsiderCreatingANewTaskWithFurtherInstructionsOrContactUsAtProjectThreadDirectly:
      null,
    pleaseProvideYourAddress: null,
    pleaseRateResults: null,
    pleaseRateTaskRusult: null,
    pleaseRateTheTask: null,
    pleaseUpdateToTheLatestVersionThisWillRefreshThePage: null,
    pleaseWaitYourDownloadWillBeReadyInSeveralMinutes: null,
    previewTextFormatting: null,
    pleaseAdjustYourFiltersAndTryAgainOr: null,
    selectInvoiceFromTheList: null,
    selectedFilesHaveBeenSuccessfullyScheduledForRestoration: null,
    restorationRequestAlreadySentEstimatedRestorationDate: null,
    sendEmailNotification: null,
    sendToWhiteboard: null,
    noItemsMatchYourSearchCriteria: null,
    noRowsToShow: null,
    noThanks: null,
    mutedThisByAccident: null,
    startTypingToSearchForClients: null,
    studioEmbedId: null,
    textFormattingHelp: null,
    thePaymentHasBeenAcceptedForProcessingUsually: null,
    thePaymentHasBeenCanceled: null,
    theTaskResultHasBeenApproved: null,
    toSetUpTheInterfaceForTheRightWorkflow: null,
    totalAmountOfImportedItems: null,
    thereAreNoNonValidTasks: null,
    thereAreNoValidTasks: null,
    theseFilesAreStoredInDeepArchiveBeforeDownloadingTheyMustFirstBeRestoredRestorationTypicallyTakesUpTo:
      null,
    onceRestoredTheFilesWillBeAvailableForDownloadFor: null,
    thisActionWillAffect: null,
    thisActionWillAddARecordTo: null,
    thisCommentWouldBeVisibleOnlyInTimeline: null,
    thereIsNoBillingInfoInTheCompany: null,
    updateCost: null,
    updateDueDate: null,
    weAreOnline: null,
    weAreReadyToHelp: null,
    whiteboardDataHasBeenUpdatedPleaseReloadThePage: null,
    writeHereWarning: null,
    youAreAboutToChangeTheClientExistingTasksItemsWillBeDeletedAreYouSureYouWantToProceed:
      null,
    youCanAlwaysDownloadTheFilesToSeeThemOnYourDeviceBeforeAcceptingTheTask:
      null,
    youWillBeRedirectedToThePaymentsPageIn: null,
    youWillBeRedirectedToTheProjectPageIn: null,
    youveSuccessfullyUnsubscribedFrom: null,
    youveSuccessfullySubscribedTo: null,
    youWontReceiveNotificationsFor: null,
    letsCreateYourFirstProject: null,
    letsDiveIn: null,
    startByOutliningYourProjectVisionBe: null,
    ourExpertTeamWillWorkCloselyWith: null,
    hereIsABriefOfOurServicesAndPricesNo: null,
    unsureClickStartProjectAnd: null,
    unlessYoureMentionedDirectly: null,
    unableToSplitInvoicesOneOrMoreInvoicesAreAssignedToDifferentGeneralLedger:
      null,
    unableToStartTask: null,
    itemsAssociatedWithDifferentLedgersInTheSmartContractAllItemsMustUseTheSameLedgerToContinuePleaseContactThePmOfThisTaskToResolveThisIssue:
      null,
    asTeamMemberOf: null,
    generateApplicationToken1: null,
    generateApplicationToken2: null,
    refreshAccessToken: null,
    remainAccessibleFor: null,
    reverseChargeForServices: null,
    yourPaymentIsBeingProcessedBeAdvisedThat: null,
    searchForProductsOnYourImageUsingAI: null,
    uploadASinglePhotoOfTheRoomAndOurAIWill: null,
    selectTheObjectYouWantToSearchInOur3DLibrary: null,
    saveFieldInCompanyProfile: null,
    submitFilesWhenUploaded: null,
    theFunctionalityIsNotAvailableForSearchWithAI: null,
    thisAccountHasBeenDeletedPleaseContactSupport: null,
    uploadAPhotoOfARoomSelectACategory: null,
    uploadedPercent: null,
    restoreSelectedFiles: null,
    yesUnmuteEverything: null,
    yesMuteEverything: null,
    wrapContent: null,
    clipContent: null,
    uploadFailedPleaseRenameTheFileUsingLatinLettersOnly: null
  },
  'strings.'
);
